// Host-based branding for the auth pages. Mirrors the first-host-segment
// checks LoginPage has always used; localhost counts as Terra so local dev
// exercises the branded layout. 'terra' and 'pay' are disjoint by
// construction — 'terra'.includes('pay') is false.
export function getHostBrand(
  host = window.location.host,
  hostname = window.location.hostname
) {
  const firstSegment = host.split('.')[0];

  if (firstSegment.includes('terra') || hostname === 'localhost') {
    return 'terra';
  }
  if (firstSegment.includes('pay')) {
    return 'pay';
  }
  return 'other';
}
